import { autofocus } from '@/autofocus-directive.ts'
import router from '@/router'
import '@logistiek-zonder-papier/lzp-library/style.css'

import Main from '@/Main.vue'
import { vueErrorHandler } from '@/global-error-handler'
import { initializeI18Next } from '@/i18next'
import { createLibraryContext } from '@/plugin'
import { axiosClient } from '@/utils/axios-client'
import { getPhoto } from '@/utils/camera.utils'
import { pinia } from '@/legacy/vue-manager.ts'
import { LzpLibrary, type CameraElement } from '@logistiek-zonder-papier/lzp-library'
import * as Sentry from '@sentry/browser'
import { createApp } from 'vue'

export const LIBRARY_CONTEXT = createLibraryContext()

Sentry.init({
  release: import.meta.env.MODE,
  environment: import.meta.env.MODE,
  dsn: import.meta.env['VITE_SENTRY_DSN'],
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({ maskAllText: false }),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [
    'localhost',
    'portal-test-lzp-portal.apps.okd.lzp.nl',
    'testidf.lzp.nl',
    'portal-stg-lzp-portal.apps.okd.lzp.nl',
    'accidf.lzp.nl',
    'portal-prod-lzp-portal.apps.okd.lzp.nl',
    'idf.lzp.nl',
  ],
  replaysSessionSampleRate: 0.01,
  replaysOnErrorSampleRate: 1.0,
})

async function main() {
  const app = createApp(Main)

  await initializeI18Next(app)
  app.config.errorHandler = vueErrorHandler
  app.use(pinia)
  app.use(router)
  app.use(LzpLibrary, {
    getPhoto: async (config: CameraElement) => await getPhoto(config),
    request: axiosClient.request,
    context: LIBRARY_CONTEXT,
    environment: import.meta.env.MODE,
  })
  app.directive('autofocus', autofocus)
  app.mount('#app')
}

void main()
